/**
 * SSR configuration and global settings
 * This module sets up the SSR environment and provides global constants
 * 
 * NOTA: Questo file è importato anche dal client, quindi NON usare moduli Node.js (fs, path, etc.)
 * Il caricamento dinamico dei fallback da file avviene solo in fallbackPriceService.js (server-only)
 */

// Set SSR flag for the entire process
export const setupSSREnvironment = (): void => {
  if (typeof globalThis !== 'undefined') {
    if (!('process' in globalThis)) {
      // Use type assertion to avoid TypeScript errors
      (globalThis as any).process = { env: {} };
    } else if (!(globalThis as any).process.env) {
      (globalThis as any).process.env = {};
    }

    (globalThis as any).process.env.SSR = 'true';
  }
};

// Default fallback values for metal prices (Gennaio 2026)
// Questi valori sono usati come ultima risorsa se l'API e il file dinamico non sono disponibili
// Il server aggiorna automaticamente fallback-prices.json ad ogni fetch riuscito
// HYDRATION FIX: timestamp vuoto per evitare mismatch SSR/client (#418/#423)
export const FALLBACK_METAL_PRICES = {
  gold: { price: 130.00, timestamp: '' },
  silver: { price: 2.50, timestamp: '' }
};

// Timeout for data fetching operations (in milliseconds)
export const FETCH_TIMEOUT = 5000;

// Default pagination values
export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 50; // Aumentato per migliore cache coverage

// Base URL for canonical links
export const BASE_URL = 'https://www.gildy.it';

// Default image for SEO
export const DEFAULT_IMAGE = 'https://www.gildy.it/logo.png';

// Global data keys
export const GLOBAL_KEYS = {
  SERVER_STORE: '__SERVER_STORE',
  SERVER_RATINGS: '__SERVER_RATINGS',
  BLOG_POSTS: '__BLOG_POSTS',
  PREDICTIONS_DATA: '__PREDICTIONS_DATA',
  SERVER_RENDER_TIME: '__SERVER_RENDER_TIME',
  INITIAL_DEALER_DATA: '__INITIAL_DEALER_DATA',
  SERVER_DEALERS: '__SERVER_DEALERS',
  SERVER_CITIES: '__SERVER_CITIES',
  SERVER_FORMATTED_CITY: '__SERVER_FORMATTED_CITY'
};
